import React from 'react';

import Button from 'components/Button';
import clsx from 'clsx';

const Explanation = ({explanation, isTrue, next}) => (
  <div className={clsx("content my-3 p-5", {"has-background-success-light": isTrue}, {"has-background-danger-light": !isTrue})}>
    <p className={clsx("is-size-5 has-text-centered mb-3", {"has-text-success": isTrue}, {"has-text-danger": !isTrue})}>
      {isTrue &&
        "Félicitations ! C'était la bonne réponse"
      }
      {!isTrue &&
        "Mauvaise réponse"
      }
    </p>
    <p className="is-size-5 has-text-centered break-word">
      {explanation}
    </p>
    <div className="has-text-centered mb-3">
    <Button className="is-text is-primary" onClick={next}>
      Suivant
      {/* Add countdown until next */}
    </Button>
    </div>
  </div>
)

export default Explanation;